export const camelCaseToTitle = (camelCase) =>
    camelCase
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase());
